import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';
export const hasTransportTask = (value) => !!value.task;
const MapTransportTaskList = ({ value, onItemColumnClick }) => {
    var _a;
    const { conditions: conditionItems, task } = value;
    const lastCondition = conditionItems[conditionItems.length - 1];
    return (React.createElement(Box, { component: 'div', sx: { width: '100%', height: '100%' } },
        React.createElement(List, { disablePadding: true, sx: (theme) => ({
                padding: theme.spacing(0),
                border: '1px solid',
                borderColor: theme.palette.divider,
                borderRadius: theme.shape.borderRadius,
                overflow: 'hidden',
            }) },
            React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    zIndex: '2',
                    pointerEvents: 'none',
                    padding: theme.spacing(0),
                    '.MuiListItemText-root': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '100%',
                        position: 'relative',
                        flex: 'none',
                        '&:before': {
                            content: '""',
                            position: 'absolute',
                            top: '0',
                            right: '0',
                            height: '100%',
                            bgcolor: theme.palette.divider,
                            width: '1px',
                            zIndex: '1',
                            pointerEvents: 'none',
                        },
                        '&:last-of-type': {
                            flex: '1',
                            '&:before': {
                                display: 'none',
                            },
                        },
                    },
                }) }, config.mapTransportTaskColumns.map((column) => (React.createElement(ListItemText, { key: column.name, style: { width: column.width } })))),
            React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                    width: '100%',
                    userSelect: 'none',
                    borderRadius: '0',
                    '.MuiListItemText-root': {
                        display: 'flex',
                        flex: 'none',
                        margin: theme.spacing(0),
                        padding: theme.spacing(1),
                        alignItems: 'center',
                        bgcolor: 'background.default',
                        borderBottom: '1px solid',
                        borderColor: theme.palette.divider,
                        '&:first-of-type': {
                            paddingLeft: theme.spacing(2),
                        },
                        '&:last-of-type': {
                            flex: '1',
                            paddingRight: theme.spacing(2),
                        },
                        '.MuiTypography-root': {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        },
                    },
                }) }, config.mapTransportTaskColumns.map((column) => (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                React.createElement(Typography, null, column.label))))),
            ((_a = task.ttn_task) !== null && _a !== void 0 ? _a : []).map((ttnTask, key) => (React.createElement(ListItem, { key: key, disablePadding: true, sx: (theme) => ({
                    width: '100%',
                    userSelect: 'none',
                    borderRadius: '0',
                    '.MuiListItemText-root': {
                        display: 'flex',
                        flex: 'none',
                        margin: theme.spacing(0),
                        padding: theme.spacing(0.5, 1),
                        alignItems: 'center',
                        '&:first-of-type': {
                            paddingLeft: theme.spacing(2),
                        },
                        '&:last-of-type': {
                            flex: '1',
                            paddingRight: theme.spacing(2),
                        },
                        '.MuiTypography-root': {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        },
                    },
                }) }, config.mapTransportTaskColumns.map((column) => {
                var _a;
                switch (column.name) {
                    case 'section':
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                            React.createElement(Typography, null, ttnTask.section)));
                    case 'gs_num':
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, onClick: () => onItemColumnClick(ttnTask), sx: {
                                width: column.width,
                                cursor: ttnTask.geofence_id ? 'pointer' : 'default',
                            } },
                            React.createElement(Typography, null, ttnTask.gs_num)));
                    case 'product':
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                            React.createElement(Typography, null, ttnTask.product)));
                    case 'volume':
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                            React.createElement(Typography, null, ttnTask.volume)));
                    case 'dut': {
                        const dutKey = `dut${ttnTask.section}`;
                        const dutValue = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data[dutKey];
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                            React.createElement(Typography, null, Object.prototype.hasOwnProperty.call((_a = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data) !== null && _a !== void 0 ? _a : {}, dutKey)
                                ? dutValue === config.conditions.dut.default
                                    ? '0'
                                    : dutValue
                                : '0')));
                    }
                    default:
                        return null;
                }
            })))))));
};
export default MapTransportTaskList;
